module.exports = __webpack_public_path__ + "img/box3.8b3b38f3.png";